// import req from "../../http/requests/dealership/index.js";
import http from '../../http/requests/user/index.js'

export default {
  fetchUser(context, userID) {
    return new Promise((resolve, reject) => {
      http
        .fetchUser(userID)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchUsers({commit}) {
    return new Promise((resolve, reject) => {
      http
        .fetchUsers()
        .then(response => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addUser({commit}, payload) {
    return new Promise((resolve, reject) => {
      http
        .addUser(payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editUser({commit}, payload) {
    return new Promise((resolve, reject) => {
      http
        .editUser(payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteUser(context, userID) {
    return new Promise((resolve, reject) => {
      http
        .deleteUser(userID)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
